module.exports = __webpack_public_path__ + "media/application/images/ui/logo-consumer-trusted-f1d53a71d8c8c44b7850a6e921be440b.png";